import { OnTileLoaded } from "../types/Tile";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";
import { fetchTile, insertTile } from "./LazyTile";
import { trackColorSwitch } from "./ColorChangeTracking";

/**
 *
 *
 *
 *
 */
function replaceNode(node: Node, replacement: Node): void {
  const range = document.createRange();
  /*                                 */
  range.selectNode(node);

  /*           */
  range.deleteContents();
  range.insertNode(replacement);
}

/**
 *
 *
 *
 *
 *
 *
 */
function toggleItem(activatedName: string, selectedClass: string, elem: HTMLElement): boolean {
  const { colorName } = elem.dataset;
  const activate = colorName === activatedName;
  const isActive = !elem.classList.contains(selectedClass);
  elem.classList.toggle(selectedClass, activate);
  return activate !== isActive;
}

/**
 *
 *
 *
 *
 *
 */
function updateContent(activatedName: string, selectedClass: string, switchableItems: NodeListOf<Element>) {
  return Array.prototype.map
    .call(switchableItems, toggleItem.bind(switchableItems.item, activatedName, selectedClass))
    .reduce((acc, cur) => acc || cur, false);
}

/**
 *
 *
 */
function applyPreviousScrollPosition(tileContainer: HTMLElement, colorThumbs: HTMLElement) {
  const scrollPosString = tileContainer.dataset.lastScrollPosition;
  if (scrollPosString) {
    colorThumbs.scrollLeft = parseInt(scrollPosString, 10);
  }
}

/**
 *
 *
 */
function storeLastScrollPosition(tileContainer: HTMLElement, colorThumbs: HTMLElement) {
  tileContainer.dataset.lastScrollPosition = colorThumbs.scrollLeft + "";
}

/**
 *
 */
async function onChange(tileContainer: HTMLElement, event: Event) {
  const target = event.target as HTMLElement;
  const colorThumb = target.closest(".reptile_colorThumb") as HTMLElement;

  if (colorThumb) {
    storeLastScrollPosition(tileContainer, colorThumb.closest(".reptile_colorThumbs") as HTMLElement);

    const { colorName, variationId } = colorThumb.dataset;

    if (colorName && variationId && !colorThumb?.classList.contains("reptile_colorThumb--selected")) {
      const tile = tileContainer.querySelector(`.find_tile[data-variation-id="${variationId}"]`) as HTMLElement;

      if (tile.classList.contains("js_reptile_tile--lazy")) {
        const href = tile.dataset.href;
        if (!href) {
          return;
        }
        await fetchTile(href, insertTile.bind(tile));
      } else {
        updateContent(colorName, "find_tile--visible", tileContainer.querySelectorAll(".find_tile"));
        applyPreviousScrollPosition(tileContainer, tile.querySelector(".reptile_colorThumbs") as HTMLElement);
      }

      /*                             */
      updateContent(colorName, "reptile_colorThumb--selected", tileContainer.querySelectorAll(".reptile_colorThumb"));
      trackColorSwitch(variationId, tileContainer);
    }
  }
}

export function onTileLoaded(event: OnTileLoaded) {
  const targetLi = event.target as HTMLElement;
  const tileContainerWithColorChange = targetLi.closest("ul.js_find_colorChange");
  if (tileContainerWithColorChange) {
    const { colorName } = targetLi.dataset;
    const colorThumbsPlaceholder = targetLi.querySelector(".find_tile__colorThumbs--placeholder") as Node;
    let colorThumbsContainer = tileContainerWithColorChange.querySelector(
      ".reptile_colorThumbsContainer .reptile_colorThumbs",
    ) as Node;
    colorThumbsContainer = colorThumbsContainer.cloneNode(true);

    /*                */
    if (!!colorThumbsPlaceholder && !!colorThumbsContainer) {
      replaceNode(colorThumbsPlaceholder, colorThumbsContainer);

      /*                       */
      const colorThumbsContainerInTargetLi = targetLi.querySelector(".reptile_colorThumbs") as HTMLElement;
      registerChangeListener(tileContainerWithColorChange as HTMLElement, colorThumbsContainerInTargetLi);

      tryUpdatePlusThumbLink(targetLi);

      /*                           */
      window.setTimeout(() => {
        updateContent(
          colorName as string,
          "find_tile--visible",
          tileContainerWithColorChange.querySelectorAll(".find_tile"),
        );
        applyPreviousScrollPosition(tileContainerWithColorChange as HTMLElement, colorThumbsContainerInTargetLi);
      }, 10);
    }
  }
}

function tryUpdatePlusThumbLink(tile: HTMLElement) {
  const linkThumb: Element = tile.querySelector(".js_reptile_colorThumbLink") as Element;
  const imageLink = tile.querySelector(".find_tile__productImageLink") as HTMLElement;
  if (!linkThumb || !imageLink) {
    return;
  }

  let link: string;
  if (imageLink.classList.contains("ub64e")) {
    link = atob(imageLink.getAttribute("data-ub64e") || "");
  } else {
    link = (imageLink as HTMLAnchorElement).href || "";
  }
  const plusLink = tile.querySelector(".reptile_colorThumbLink oc-link-v2") as HTMLElement;
  if (plusLink) {
    plusLink.setAttribute("base64-href", btoa(link));
  }
}

/**
 *
 *
 *
 */
function create(tileContainer: HTMLElement) {
  const colorThumbsElements = tileContainer.querySelectorAll(".js_reptile_crocotile_colors .reptile_colorThumbs");

  Array.from(colorThumbsElements).forEach((colorThumbsElement) =>
    registerChangeListener(tileContainer, colorThumbsElement as HTMLElement),
  );
}

function onTileListLoaded() {
  Array.from(document.querySelectorAll("ul.js_find_colorChange")).forEach((tileContainer) =>
    create(tileContainer as HTMLElement),
  );
}

function registerChangeListener(tileContainer: HTMLElement, colorThumbsContainer: HTMLElement) {
  colorThumbsContainer.addEventListener("click", onChange.bind(colorThumbsContainer, tileContainer));
}

export function registerColorChange() {
  eventQBus.on("ftfind.tilelist.restored", onTileListLoaded);
  eventQBus.on("ftfind.tile.loaded", onTileLoaded);
}
